import { CustomerSettingsKey, SetCustomerSettingsResponse } from "./types";
import { dashboardBFF } from "../axios-instances";
import { getServices } from "src/logs";

const { logger } = getServices();

export const setCustomerSetting = async (
  key: CustomerSettingsKey,
  value: string | boolean,
  logsDetailedFeature?: boolean | undefined
): Promise<SetCustomerSettingsResponse> => {
  try {
    const url = `/api/customer-settings/${key}`;

    const response = await dashboardBFF.put(url, {
      value: value
    });

    if (response.status === 204) {
      const err = new Error("No content, http status code: 204");
      throw err;
    }

    if (logsDetailedFeature) {
      logger.logTrace({
        message: "setCustomerSetting - setting updated",
        properties: {
          key,
          status: response.status.toString()
        }
      });
    }
    return response.data as SetCustomerSettingsResponse;
  } catch (error) {
    const err = error as Error;
    if (!err.message.includes("204")) {
      logger.logError({
        message: "setCustomerSetting - Exception",
        properties: {
          name: err.name,
          message: err.message,
          stack: err.stack || "unknown stack",
          cause: String(err.cause ?? "unknown cause")
        }
      });
    }
    throw error;
  }
};

